/* Sleepee 15.10 — skrypt trzech wersji karty produktu na telefon (templates/product.mobile-v1|v2|v3.json).
   1) v2: autoprzewijanie rzędu kółek wzorów (Paweł 18:27: „slider musi się sam przewijać”) — pauza po dotknięciu,
      tylko gdy rząd jest na ekranie, bez animacji przy prefers-reduced-motion.
   2) wszystkie wersje: dymek z tytułem i opisem cechy po kliknięciu numerka na packshocie A+ (P2) — Łukasz 14:07,
      Paweł 14:37. Dane bierze z listy pod zdjęciem (.sl-ap-co[data-h]), nic nie dubluje w HTML.
   Bez JS: kółka są zwykłymi linkami i przewijają się palcem; numerki A+ działają jak dziś. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 749px)');

  /* ---------- v2: autoprzewijanie ---------- */
  function initAuto(root) {
    var track = root.querySelector('[data-sl-pv-track]');
    if (!track) return;
    var items = track.querySelectorAll('.sl-pv__item');
    if (items.length < 2) return;
    var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    var cur = track.querySelector('.is-current');
    /* wybrany wzór widoczny na starcie (jak slider P6 w A+) */
    if (cur && cur.offsetLeft - padL + cur.offsetWidth > track.clientWidth) track.scrollLeft = cur.offsetLeft - padL;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false, pauseT = null, inView = true, prog = false, progT = null;
    var pause = function (ms) { paused = true; clearTimeout(pauseT); pauseT = setTimeout(function () { paused = false; }, ms); };
    var maxLeft = function () { return track.scrollWidth - track.clientWidth; };
    var firstIdx = function () {
      for (var i = 0; i < items.length; i++) { if (items[i].offsetLeft - padL >= track.scrollLeft - 2) return i; }
      return items.length - 1;
    };
    var step = function () {
      if (paused || !inView || document.hidden || !mobile.matches) return;
      var max = maxLeft();
      if (max <= 4) return;
      var target = track.scrollLeft >= max - 4 ? 0 : Math.min(items[Math.min(firstIdx() + 1, items.length - 1)].offsetLeft - padL, max);
      prog = true; clearTimeout(progT); progT = setTimeout(function () { prog = false; }, 900);
      track.scrollTo({ left: target, behavior: 'smooth' });
    };
    setInterval(step, 2600);
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) { track.addEventListener(ev, function () { pause(8000); }, { passive: true }); });
    track.addEventListener('scroll', function () { if (!prog) pause(8000); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.6 }).observe(track);
    }
  }

  /* ---------- A+ P2: dymek przy numerku ---------- */
  function closeTip() {
    var tip = document.querySelector('.sl-pv-tip');
    if (!tip) return;
    var anat = tip.closest('[data-aplus-anat]');
    tip.remove();
    if (anat) {
      Array.prototype.forEach.call(anat.querySelectorAll('[data-h].on'), function (e) { e.classList.remove('on'); });
      anat.classList.remove('focus');
    }
  }
  function openTip(dot) {
    var img = dot.closest('.sl-ap-anat__img'), anat = dot.closest('[data-aplus-anat]');
    if (!img || !anat) return;
    var n = dot.getAttribute('data-h');
    var open = document.querySelector('.sl-pv-tip');
    if (open && open.getAttribute('data-h') === n && open.closest('[data-aplus-anat]') === anat) { closeTip(); return; }
    closeTip();
    var co = anat.querySelector('.sl-ap-co[data-h="' + n + '"]');
    var h = co && co.querySelector('h3'), p = co && co.querySelector('p');
    var tip = document.createElement('div');
    tip.className = 'sl-pv-tip'; tip.setAttribute('data-h', n); tip.setAttribute('role', 'dialog');
    var st = document.createElement('strong'); st.textContent = n + '. ' + (h ? h.textContent.trim() : (dot.getAttribute('data-tip') || ''));
    var sp = document.createElement('span'); sp.textContent = p ? p.textContent.trim() : '';
    var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'sl-pv-tip__close';
    bt.setAttribute('aria-label', (window.SleepeePV && window.SleepeePV.close) || 'Close'); bt.innerHTML = '&times;';
    tip.appendChild(st); tip.appendChild(sp); tip.appendChild(bt);
    var ir = img.getBoundingClientRect(), dr = dot.getBoundingClientRect();
    var cx = dr.left + dr.width / 2 - ir.left, cy = dr.top + dr.height / 2 - ir.top;
    if (cy < ir.height * 0.55) { tip.classList.add('sl-pv-tip--below'); tip.style.top = Math.round(cy + 20) + 'px'; }
    else { tip.classList.add('sl-pv-tip--above'); tip.style.bottom = Math.round(ir.height - cy + 20) + 'px'; }
    tip.style.setProperty('--sl-tip-x', Math.round(Math.max(18, Math.min(cx - 12, ir.width - 42))) + 'px');
    img.appendChild(tip);
    /* podświetlenie numerka i wiersza jak w sleepee-aplus.js */
    Array.prototype.forEach.call(anat.querySelectorAll('[data-h]'), function (e) { e.classList.toggle('on', e.getAttribute('data-h') === n); });
    anat.classList.add('focus');
  }
  document.addEventListener('click', function (e) {
    if (!mobile.matches) return;
    var t = e.target;
    if (t.closest && t.closest('.sl-pv-tip__close')) { e.preventDefault(); closeTip(); return; }
    if (t.closest && t.closest('.sl-pv-tip')) return;
    var dot = t.closest && t.closest('.sl-ap-dot');
    if (dot) { e.preventDefault(); openTip(dot); return; }
    if (document.querySelector('.sl-pv-tip')) closeTip();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTip(); });

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sl-pv--slider'), function (r) { if (!r.__slAuto) { r.__slAuto = 1; initAuto(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
